/**
 * @generated SignedSource<<5ebcc8450d27889ff22028622909fd90>>
 * @relayHash fd8aee11643d0b1b09a886fbcc7575e1
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fd8aee11643d0b1b09a886fbcc7575e1

import { ConcreteRequest } from 'relay-runtime';
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type Ch_updateConsultationReportInput = {
  anamnesis: string;
  diagnosisCode: string;
  healthcareProviderId: string;
  id: string;
  isAiContentModified: boolean;
  isAiGenerated: boolean;
  language: Language;
  recommendedTreatment: string;
};
export type useUpdateConsultationReportMutation$variables = {
  input: Ch_updateConsultationReportInput;
};
export type useUpdateConsultationReportMutation$data = {
  readonly ch_updateConsultationReport: {
    readonly ch_ConsultationReport: {
      readonly anamnesis: string;
      readonly concludedAt: string | null;
      readonly concludedBy: string | null;
      readonly createdAt: string;
      readonly createdBy: string;
      readonly diagnosisCode: string;
      readonly fileId: string | null;
      readonly fileMetadata: {
        readonly documentType: string;
        readonly extension: string;
        readonly lengthInKilobytes: number;
      } | null;
      readonly healthcareProviderId: string;
      readonly id: string;
      readonly isAiContentModified: boolean;
      readonly isAiGenerated: boolean;
      readonly language: Language;
      readonly patientId: string;
      readonly progressNoteId: string;
      readonly recommendedTreatment: string;
      readonly signedAt: string | null;
      readonly updatedAt: string | null;
      readonly updatedBy: string | null;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useUpdateConsultationReportMutation = {
  response: useUpdateConsultationReportMutation$data;
  variables: useUpdateConsultationReportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_ConsultationReport",
  "kind": "LinkedField",
  "name": "ch_ConsultationReport",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progressNoteId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "concludedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "concludedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "language",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "healthcareProviderId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "diagnosisCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "anamnesis",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recommendedTreatment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAiGenerated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAiContentModified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DocumentFileMetadata",
      "kind": "LinkedField",
      "name": "fileMetadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "extension",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lengthInKilobytes",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": (v3/*:: as any*/),
  "type": "DocumentDoesNotExist",
  "abstractKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": (v3/*:: as any*/),
  "type": "FieldLengthInvalid",
  "abstractKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": (v3/*:: as any*/),
  "type": "ConsultationReportCareProviderNotFound",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateConsultationReportMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updateConsultationReportPayload",
        "kind": "LinkedField",
        "name": "ch_updateConsultationReport",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useUpdateConsultationReportMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updateConsultationReportPayload",
        "kind": "LinkedField",
        "name": "ch_updateConsultationReport",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "fd8aee11643d0b1b09a886fbcc7575e1",
    "metadata": {},
    "name": "useUpdateConsultationReportMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b8a74a5e28e2e5de4fd66c6914c8f472";

export default node;
